<template>
	<nav v-if="hasItems" class="menu history">
		<div class="menu-header"><span class="menu-title">{{ env.msg('history.title') }}</span><span style="opacity:0.5"><sym-icon name="history"></sym-icon></span></div>
		<div class="menu-body">
			<template v-for="(hi, idx) in navStore.historyItems">
				<it-link :to="hiAction(hi.action)" class="menu-item" :class="extraClasses(hi, idx)" v-bind="attrsFor(hi)"><sym-icon :name="hi.icon" class="menu-fi-dot"></sym-icon><span class="mi mi-label">{{ hi.title }}</span></it-link>
			</template>
		</div>
	</nav>
</template>

<script setup lang="ts">
import {injectEnv} from "@fd/Environment";
import SymIcon from "@fd/helpers/SymIcon.vue";
import type {FormEnvironment} from "@fd/Types";
import ItLink from "@/router/ItLink.vue";
import {HistoryObject} from "@t/meta/History";
import {useNavigationStore} from "@/store/NavigationStore.ts";
import {computed} from "vue";

const env:FormEnvironment = injectEnv();
const navStore = useNavigationStore();

const hasItems = computed<boolean>(() => {
	return navStore.historyItems.length > 0;
});

function hiAction(action:string):string {
	return window.Server.context + "/" + action
}

function attrsFor(hi: HistoryObject):object {
	if (hi.target) return { target: hi.target };
	return null;
}

function extraClasses(hi: HistoryObject, idx: number) {
	const c:string[] = [];
	if (hi.separated) c.push("menu-item-separated");
	return c;
}
</script>

<style>

</style>